"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROOT = void 0;
const typedRoute_1 = require("typedRoute");
exports.ROOT = (0, typedRoute_1.root)();
